import { toast as sonnerToast } from "sonner";

export function useToast() {
  return {
    toast: ({ title, description, variant } = {}) => {
      const isDestructive = variant === "destructive";

      if (isDestructive) {
        return sonnerToast.error(title || "Error", { description });
      }

      return sonnerToast(title || "Notification", { description });
    },
  };
}

